import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import calendarSaga from "./calendar/saga"
import chatSaga from "./chat/saga"
import dashboardSaga from "./dashboard/saga"
import UserSaga from "./user/saga"
import RegionSaga from "./regions/saga"
import BusinessSaga from "./business/saga"
import RolesSaga from "./role/saga"
import LogoSaga from "./logo/sagas"
import StyleSaga from "./style/saga"
import TemplateSaga from "./templates/saga"
import SectionSaga from "./sections/saga"
import SnippetsSaga from "./snippets/sagas"
import filterBarSagas from "./filterBar/sagas"
import DocumentSaga from "./documents/saga"
import WorkflowSaga from "./workflow/saga"
import documentCenterSaga from "./documentCenter/saga"

export default function* rootSaga() {
  yield all([
    //public
    AccountSaga(),
    fork(AuthSaga),
    ProfileSaga(),
    ForgetSaga(),
    LayoutSaga(),
    fork(calendarSaga),
    fork(chatSaga),
    fork(dashboardSaga),
    RolesSaga(),
    UserSaga(),
    RegionSaga(),
    BusinessSaga(),
    LogoSaga(),
    StyleSaga(),
    TemplateSaga(),
    SectionSaga(),
    SnippetsSaga(),
    filterBarSagas(),
    DocumentSaga(),
    WorkflowSaga(),
    documentCenterSaga(),
  ])
}
